import InternalLink from '@components/utils/links/internalLink';
import styled from '@emotion/styled';
import { EmbedPostMessageEvent } from '@lib/embed/enums';
import { useEmbedContext } from '@lib/embed/providers/EmbedProvider';
import { postMessageToEmbed } from '@lib/embed/utils/postMessageToEmbed';
import { Button, IconButton } from '@lib/uikit';
import Head from 'next/head';
import Image from 'next/legacy/image';

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    position: relative;
`;

const ExitButtonContainer = styled.div`
    position: absolute;
    top: ${(props) => props.theme.spacing.md};
    right: ${(props) => props.theme.spacing.md};
`;

const StyledButton = styled(Button)`
    width: 50%;
    height: ${(props) => props.theme.spacing.xxl};
    margin: ${(props) => props.theme.spacing.md};
    margin-left: auto;
    margin-right: auto;
    border-radius: ${(props) => props.theme.spacing.sm};
    align-self: center;
    font: ${(props) => props.theme.fonts.body};
`;

const ImageContainer = styled.div`
    display: flex;
    justify-content: center;
    margin: 20px 0px 20px 0px;
    padding: 0px 20px 0px 20px;
    width: 100%;
`;

const SImage = styled(Image)`
    padding: 20px;
    max-width: 300px;
`;

const Text = styled.p`
    font: ${(props) => props.theme.fonts.heading4};
    text-align: center;
`;

interface ErrorPageProps {
    title: string;
    message: string;
    imageSrc?: string;
    showImage?: boolean;
}

export function ErrorPage({
    title,
    message,
    imageSrc = '/assets/error_illustration.png',
    showImage = true,
}: ErrorPageProps) {
    const { isEmbedContextLoading, isEmbed } = useEmbedContext();

    const handleCloseEmbed = () => {
        postMessageToEmbed(EmbedPostMessageEvent.DIALOG_CLOSE);
    };

    return (
        <Container>
            <Head>
                <title>{title}</title>
                <meta name='robots' content='noindex' />
            </Head>
            {!isEmbedContextLoading && isEmbed && (
                <ExitButtonContainer>
                    <IconButton
                        ariaLabel='Close'
                        icon='close'
                        color='black'
                        buttonSize='large'
                        onClick={handleCloseEmbed}
                    />
                </ExitButtonContainer>
            )}
            {showImage && (
                <ImageContainer>
                    <SImage
                        max-height='300px'
                        height='300'
                        src={imageSrc}
                        width='300'
                    />
                </ImageContainer>
            )}
            <Text>{message}</Text>
            {!isEmbedContextLoading && isEmbed ? (
                <StyledButton
                    buttonSize='large'
                    colorScheme='black'
                    onClick={handleCloseEmbed}
                >
                    Close
                </StyledButton>
            ) : (
                <StyledButton as={InternalLink} href='/'>
                    Homepage
                </StyledButton>
            )}
        </Container>
    );
}
